<template>
<div class="chapter">
<div class="inner_page">
<div id="sec-6">
<p class="noindent1" id="pz6-6" style="margin-top:4em;"><b>DISCIPLESHIP IN COMMUNITY</b><br/><i>A Theological Vision for the Future</i></p>
<div class="image" id="AVYo" style="text-align:left;margin-top:0.5em;">
<img alt="images/himg-6-1.png" id="AFc" src="images/himg-6-1.png"/>
</div>
<p class="copy" id="Aj_">Copyright © 2020 by Mark E. Powell, John Mark Hicks, and Greg McKinzie</p>
<p class="copy" id="AUR">ISBN 978-1-68426-410-1 | LCCN 2019056910</p>
<p class="copy" id="A0O">Printed in the United States of America</p>
<p class="copy" id="A7n">ALL RIGHTS RESERVED<br/>No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form by any means—electronic, mechanical, photocopying, recording, or otherwise—without prior written consent.</p>
<p class="copy2" id="pz6-8">All scripture quotations, unless otherwise indicated, are taken from the Holy Bible, New International Version<sup>®</sup>, NIV<sup>®</sup>. Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.™ Used by permission of Zondervan. All rights reserved worldwide.</p>
<hr/>
<p class="copy1" id="AIW">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</p>
<p class="copy1" id="pz6-10">Names: Powell, Mark E., author. | Hicks, John Mark, author. | McKinzie, Greg, 1982- author.</p>
<p class="copy1" id="pz6-11">Title: Discipleship in community : a theological vision for the future / Mark E. Powell, John Mark Hicks and Greg McKinzie.</p>
<p class="copy1" id="pz6-12">Description: Abilene, Texas : Abilene Christian University Press, 2020. | Includes bibliographical references.</p>
<p class="copy1" id="pz6-13">Identifiers: LCCN 2019056910 | ISBN 9781684264100 (paperback)</p>
<p class="copy1" id="Alj">Subjects: LCSH: Churches of Christ. | Christian life. | Theology, Doctrinal. | Christianity—21st century.</p>
<p class="copy1" id="AXy">Classification: LCC BX7076 .P69 2020 | DDC 230/.6634—dc23</p>
<p class="copy1" id="AWJ">LC record available at <a href="https://lccn.loc.gov/2019056910" id="AJ7R" target="_blank">https://lccn.loc.gov/2019056910</a></p>
<hr/>
<p class="copy" id="AYq">Cover design by ThinkPen Design<br/>Interior text design by Sandy Armstrong, Strong Design</p>
<p class="copy" id="Anx">For information contact:<br/>Abilene Christian University Press<br/>ACU Box 29138<br/>Abilene, Texas 79699</p>
<p class="copy" id="AM-">1-877-816-4455<br/><a href="http://www.acupressbooks.com" id="A6Ix" target="_blank">www.acupressbooks.com</a></p>
<p class="copyc" id="Ah4">20 21 22 23 24 25 26 / 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?1c0f963a